<template>
  <div class="about-page">
    <!-- 四模块整屏滚动 -->
    <div
      v-for="(item, index) in sections"
      :key="item.key"
      class="fullscreen-section reveal-section"
      :class="[item.className, { 'is-visible': visibleMap[index] }]"
    >
      <div class="section-canvas" :style="{ transform: 'scale(' + scale + ')' }">
        <!-- 模块一/模块三背景图：置于动效容器之外，不参与渐入动效（始终直接显示） -->
        <img v-if="item.key === 'hero'" class="mod1-bg" src="@/assets/images/about/about-1-company.png" alt="">
        <img v-if="item.key === 'feature'" class="mod3-bg" src="@/assets/images/about/about-3-back.png" alt="">
        <div class="section-inner">

          <!-- ============ 模块一 ============ -->
          <div v-if="item.key === 'hero'" class="mod1-layout">
            <!-- 模块一文字与按钮：居中叠加在背景图上方 -->
            <div class="mod1-content">
              <h1 class="mod1-title">{{ $t('about.heroTitle') }}</h1>
              <p class="mod1-subtitle">{{ $t('about.heroSubtitle') }}</p>
              <!-- 招聘功能不提供英文版：英文下隐藏加入我们按钮（v-if 移出 DOM，点击一并失效） -->
              <button v-if="$i18n.locale !== 'en'" class="mod1-btn" @click="$router.push('/join')">{{ $t('about.heroBtn') }} &gt;</button>
            </div>
          </div>

          <!-- ============ 模块二 ============ -->
          <div v-if="item.key === 'intro'" class="mod2-layout">
            <!-- 模块二标题区 -->
            <div class="mod2-header">
              <h2 class="mod2-title">{{ $t('about.introTitle') }}</h2>
              <p class="mod2-subtitle">{{ $t('about.introSubtitle') }}</p>
            </div>
            <!-- 模块二分割线 -->
            <div class="mod2-divider"></div>
            <!-- 模块二公司介绍文字 -->
            <p class="mod2-desc">{{ $t('about.companyDesc') }}</p>
            <!-- 模块二左侧图标行：研发/设计/生产三个图标横向排列 -->
            <div class="mod2-icons">
              <div class="mod2-icon-item">
                <img class="mod2-icon" src="@/assets/images/about/about-2-1.png" alt="">
                <span class="mod2-icon-label">{{ $t('about.iconLabel1') }}</span>
              </div>
              <div class="mod2-icon-item">
                <img class="mod2-icon" src="@/assets/images/about/about-2-2.png" alt="">
                <span class="mod2-icon-label">{{ $t('about.iconLabel2') }}</span>
              </div>
              <div class="mod2-icon-item">
                <img class="mod2-icon" src="@/assets/images/about/about-2-3.png" alt="">
                <span class="mod2-icon-label">{{ $t('about.iconLabel3') }}</span>
              </div>
            </div>
            <!-- 模块二右侧公司图片：独立 img 元素，垂直居中靠右 -->
            <img class="mod2-img" src="@/assets/images/about/about-2-company.png" alt="">
          </div>

          <!-- ============ 模块三 ============ -->
          <div v-if="item.key === 'feature'" class="mod3-layout">
            <!-- 模块三标题区：发展历程 + 长横线 -->
            <div class="mod3-header">
              <h2 class="mod3-title">{{ $t('about.devTitle') }}</h2>
              <div class="mod3-title-line"></div>
            </div>
            <!-- 发展历程时间轴：从左到右 2026/2025/2024/2021，偶数项在上方，奇数项在下方 -->
            <div class="mod3-timeline">
              <div class="tl-line"></div>
              <!-- 2026年（下方） -->
              <div class="tl-item">
                <div class="tl-year"><span class="tl-year-num">{{ $t('about.devYear1') }}</span><span v-if="$i18n.locale === 'zh'" class="tl-year-char">年</span></div>
                <p class="tl-desc">{{ $t('about.devDesc1') }}</p>
                <div class="tl-stem tl-stem-2026"></div>
                <div class="tl-node tl-node-2026"></div>
                <div class="tl-year-bar tl-year-bar-2026"></div>
              </div>
              <!-- 2025年（上方） -->
              <div class="tl-item">
                <div class="tl-node tl-node-2025"></div>
                <div class="tl-stem tl-stem-2025"></div>
                <div class="tl-year"><span class="tl-year-num">{{ $t('about.devYear2') }}</span><span v-if="$i18n.locale === 'zh'" class="tl-year-char">年</span></div>
                <p class="tl-desc">{{ $t('about.devDesc2') }}</p>
                <div class="tl-year-bar tl-year-bar-2025"></div>
              </div>
              <!-- 2024年（下方） -->
              <div class="tl-item">
                <div class="tl-year"><span class="tl-year-num">{{ $t('about.devYear3') }}</span><span v-if="$i18n.locale === 'zh'" class="tl-year-char">年</span></div>
                <p class="tl-desc">{{ $t('about.devDesc3') }}</p>
                <div class="tl-stem tl-stem-2024"></div>
                <div class="tl-node tl-node-2024"></div>
                <div class="tl-year-bar tl-year-bar-2024"></div>
              </div>
              <!-- 2021年（上方） -->
              <div class="tl-item">
                <div class="tl-node tl-node-2021"></div>
                <div class="tl-stem tl-stem-2021"></div>
                <div class="tl-year"><span class="tl-year-num">{{ $t('about.devYear4') }}</span><span v-if="$i18n.locale === 'zh'" class="tl-year-char">年</span></div>
                <p class="tl-desc">{{ $t('about.devDesc4') }}</p>
                <div class="tl-year-bar tl-year-bar-2021"></div>
              </div>
            </div>
          </div>

          <!-- ============ 模块四 ============ -->
          <div v-if="item.key === 'contact'" class="mod4-layout">
            <!-- 模块四标题区：联系我们 + 长横线 -->
            <div class="mod4-header">
              <h2 class="mod4-title">{{ $t('about.contactTitle') }}</h2>
              <div class="mod4-title-line"></div>
            </div>
            <!-- 模块四左侧文字：公司名称 + 联系方式 -->
            <div class="mod4-left">
              <h3 class="mod4-company">{{ $t('about.companyName') }}</h3>
              <div class="mod4-company-line"></div>
              <div class="mod4-section">
                <h4 class="mod4-section-title">{{ $t('about.afterSalesTitle') }}</h4>
                <p class="mod4-info"><span class="mod4-info-label">{{ $t('about.afterSalesEmail') }}</span><span class="mod4-info-value">{{ $t('about.afterSalesEmailValue') }}</span></p>
                <!-- 联系电话行：英文下隐藏（见 CSS 中 :lang(en) .mod4-info-phone 规则） -->
                <p class="mod4-info mod4-info-phone"><span class="mod4-info-label">{{ $t('about.afterSalesPhone') }}</span><span class="mod4-info-value">{{ $t('about.afterSalesPhoneValue') }}</span></p>
              </div>
              <div class="mod4-section">
                <h4 class="mod4-section-title">{{ $t('about.businessTitle') }}</h4>
                <p class="mod4-info"><span class="mod4-info-label">{{ $t('about.businessEmail') }}</span><span class="mod4-info-value">{{ $t('about.businessEmailValue') }}</span></p>
                <!-- 联系电话行：英文下隐藏（见 CSS 中 :lang(en) .mod4-info-phone 规则） -->
                <p class="mod4-info mod4-info-phone"><span class="mod4-info-label">{{ $t('about.businessPhone') }}</span><span class="mod4-info-value">{{ $t('about.businessPhoneValue') }}</span></p>
              </div>
            </div>
            <!-- 模块四右侧二维码：两张图+标签包在横向容器内，手机端并排显示；英文版隐藏 -->
            <div v-if="$i18n.locale !== 'en'" class="mod4-qr-row">
              <div class="mod4-qr-item">
                <img class="mod4-img1" src="@/assets/images/about/about-4-1.png" alt="">
                <div class="mod4-qr-label mod4-qr-label1">{{ $t('about.qrLabel1') }}</div>
              </div>
              <div class="mod4-qr-item">
                <img class="mod4-img2" src="@/assets/images/about/about-4-2.png" alt="">
                <div class="mod4-qr-label mod4-qr-label2">{{ $t('about.qrLabel2') }}</div>
              </div>
            </div>
            <!-- 模块四右侧公司地址 -->
            <div class="mod4-address">
              <h4 class="mod4-section-title">{{ $t('about.addressTitle') }}</h4>
              <p class="mod4-address-desc">{{ $t('about.addressDesc') }}</p>
            </div>
          </div>

        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from '../components/Footer.vue'

export default {
  name: 'AboutPage',
  components: {
    Footer
  },
  data() {
    return {
      scale: 1,
      baseZoom: 1,
      sections: [
        { key: 'hero', className: 'module-hero' },
        { key: 'intro', className: 'module-intro' },
        { key: 'feature', className: 'module-feature' },
        { key: 'contact', className: 'module-contact' }
      ],
      visibleMap: {},
      observer: null
    }
  },
  mounted() {
    // 滚动吸附由 App.vue 按断点统一管理
    this.baseZoom = window.devicePixelRatio || 1
    this.updateScale()
    window.addEventListener('resize', this.updateScale)
    this.initObserver()
    this.scrollToQueryModule()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateScale)
    if (this.observer) {
      this.observer.disconnect()
      this.observer = null
    }
  },
  methods: {
    updateScale() {
      // 手机端（≤1024px）禁用画布缩放，让 CSS 媒体查询接管布局
      if (window.innerWidth <= 1024) {
        this.scale = 1
        return
      }
      const fit = Math.max(window.innerWidth / 1920, window.innerHeight / 1080)
      const zoom = (window.devicePixelRatio || 1) / this.baseZoom
      this.scale = fit * zoom
    },
    initObserver() {
      if (!('IntersectionObserver' in window)) {
        this.sections.forEach((item, index) => {
          this.$set(this.visibleMap, index, true)
        })
        return
      }
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const index = Number(entry.target.dataset.index)
          this.$set(this.visibleMap, index, entry.isIntersecting)
        })
      }, {
        threshold: 0.15
      })
      this.$nextTick(() => {
        const els = this.$el.querySelectorAll('.reveal-section')
        els.forEach((el, index) => {
          el.dataset.index = index
          this.observer.observe(el)
        })
      })
    },
    // 页脚带 ?to= 参数进入时滚到对应模块（intro 模块二 / feature 模块三 / contact 模块四）；
    // 延迟一拍等页面渲染完成后再滚动，避免 scroll-snap 与渐入动效干扰
    scrollToQueryModule() {
      const anchor = this.$route.query.to
      if (!anchor) return
      this.$nextTick(() => {
        setTimeout(() => {
          const el = document.querySelector('.module-' + anchor)
          if (el) {
            el.scrollIntoView({ behavior: 'auto' })
          }
        }, 100)
      })
    }
  }
}
</script>

<style scoped>
/* ============================================================
 * 页面级公共样式（整屏容器、画布、动效）
 * ============================================================ */

.about-page {
  padding-top: 0;
}

/* 全屏高度纵向模块，配合页面级 scroll-snap 实现整屏吸附切页 */
.fullscreen-section {
  height: 100vh;
  /* 手机端用 JS 实时写入的可见高度（App.vue），避免 100vh 高于可见区导致底部裁切；桌面不受影响 */
  height: var(--app-height, 100vh);
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  scroll-snap-align: start;
  scroll-snap-stop: always;
}

.reveal-section {
  position: relative;
}

/* 设计稿画布：四个模块共用的固定尺寸容器，整体等比缩放 */
.section-canvas {
  position: relative;
  width: 1920px;
  height: 1080px;
  flex-shrink: 0;
  transform-origin: center center;
}

.reveal-section .section-inner {
  position: relative;
  width: 100%;
  height: 100%;
  opacity: 0;
  transform: translateY(48px);
  /* 隐藏态不设过渡：切页离开瞬间重置，切回时子元素独立动效完整重播 */
  will-change: opacity, transform;
}

.reveal-section.is-visible .section-inner {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.2s cubic-bezier(0.25, 0.46, 0.45, 0.94),
    transform 1.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

/* ============================================================
 * 模块一
 * ============================================================ */

.module-hero {
  background: #F5F5F5;
}

/* 模块一容器：相对定位 + 溢出裁切，为背景图提供定位基准 */
.module-hero .mod1-layout {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

/* 模块一背景图：absolute 铺满，cover 裁切，不响应鼠标事件；
   位于动效容器 .section-inner 之外，不参与渐入动效 */
.module-hero .mod1-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
  pointer-events: none;
  z-index: 0;
}

/* 模块一文字与按钮容器：居中叠加在背景图上方 */
.module-hero .mod1-content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
}

/* 模块一主标题 */
.module-hero .mod1-title {
  font-size: 80px;
  font-weight: 500;
  color: #FFFFFF;
  letter-spacing: 4px;
  margin: 0;
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
}

/* 仅英文生效：主标题分两行后文字居中对齐 */
:lang(en) .module-hero .mod1-title {
  text-align: center;
}

/* 模块一副标题 */
.module-hero .mod1-subtitle {
  font-size: 38px;
  color: rgba(255, 255, 255, 0.7);
  letter-spacing: 2px;
  margin: 0;
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
}

/* 模块一按钮：描边样式，悬停填充 */
.module-hero .mod1-btn {
  padding: 12px 36px;
  font-size: 20px;
  color: #FFFFFF;
  background: transparent;
  border: 1.5px solid rgba(255, 255, 255, 0.6);
  border-radius: 30px;
  cursor: pointer;
  letter-spacing: 1px;
  transition: background 0.3s ease, color 0.3s ease, border-color 0.3s ease;
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
}

.module-hero .mod1-btn:hover {
  background: #FFFFFF;
  color: #333333;
  border-color: #FFFFFF;
}

/* ------------------------------------------------------------
 * 模块一动效独立拆分：文字（主标题+副标题）与加入我们按钮各自为一个动效，互不影响，
 * 透明度与父层 .section-inner 相乘生效；隐藏态不设过渡，切页离开瞬间重置，切回来完整重播。
 * 每组调节点：改 0.8s 调动画时长，改末尾延迟调晚多久出现，改 translateY(24px) 调上移幅度；
 * 按钮可见态需保留 background/color/border-color 过渡，否则悬停填充效果失效。
 * ------------------------------------------------------------ */

/* 第1组：文字（主标题+副标题），延迟 0s */
.reveal-section .mod1-title,
.reveal-section .mod1-subtitle {
  opacity: 0;
  transform: translateY(24px);
}

.reveal-section.is-visible .mod1-title,
.reveal-section.is-visible .mod1-subtitle {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 0.8s ease 0s,
    transform 0.8s ease 0s;
}

/* 第2组：加入我们按钮（.mod1-btn），延迟 0.2s 错开入场 */
.reveal-section .mod1-btn {
  opacity: 0;
  transform: translateY(24px);
}

.reveal-section.is-visible .mod1-btn {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 0.8s ease 0.4s,
    transform 0.8s ease 0.2s,
    background 0.3s ease,
    color 0.3s ease,
    border-color 0.3s ease;
}

/* ============================================================
 * 模块二
 * ============================================================ */

.module-intro {
  background: #FFFFFF;
}

/* 模块二容器：相对定位，为右侧图片提供定位基准 */
.module-intro .mod2-layout {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

/* 模块二右侧图片：垂直居中靠右，独立控制尺寸 */
.module-intro .mod2-img {
  position: absolute;
  right: 200px;
  top: 50%;
  transform: translateY(-50%);
  width: 760px;
  height: auto;
}

/* 模块二标题区：左上角定位 */
.module-intro .mod2-header {
  position: absolute;
  left: 276px;
  top: 220px;
}

/* 模块二主标题 */
.module-intro .mod2-title {
  font-size: 50px;
  font-weight: 500;
  color: #252525;
  margin: 0 0 8px 0;
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
}

/* 模块二副标题 */
.module-intro .mod2-subtitle {
  font-size: 28px;
  font-weight: 400;
  color: #666666;
  margin: 0;
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
}

/* 模块二分割线 */
.module-intro .mod2-divider {
  position: absolute;
  left: 276px;
  top: 370px;
  width: 390px;
  height: 1px;
  background: #D9D9D9;
}

/* 模块二公司介绍文字 */
.module-intro .mod2-desc {
  position: absolute;
  left: 276px;
  top: 400px;
  width: 600px;
  font-size: 20px;
  font-weight: 400;
  color: #868686;
  line-height: 1.8;
  margin: 0;
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  text-align: justify;
}

/* 仅英文生效：公司介绍文字两端对齐（左右都对齐），改 width 调换行宽度 */
:lang(en) .module-intro .mod2-desc {
  text-align: justify;
  top: 385px;
}

/* 模块二左侧图标行：三个图标横向排列，位于左侧文字下方 */
.module-intro .mod2-icons {
  position: absolute;
  left: 260px;
  top: 720px;
  display: flex;
  align-items: center;
  gap: 200px;
}

/* 模块二单个图标项：图标 + 标签垂直排列 */
.module-intro .mod2-icon-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

/* 模块二单个图标：独立控制尺寸 */
.module-intro .mod2-icon {
  width: 70px;
  height: auto;
}

/* 模块二图标下方标签文字 */
.module-intro .mod2-icon-label {
  font-size: 20px;
  font-weight: 500;
  color: #252525;
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
}

/* ------------------------------------------------------------
 * 模块二动效独立拆分：标题区（主标题+副标题）与介绍文字各自为一个动效，
 * 隐藏态不设过渡，切页离开瞬间重置，切回来完整重播。
 * 每组调节点：改 0.8s 调动画时长，改末尾延迟调晚多久出现，改 translateY(24px) 调上移幅度。
 * ------------------------------------------------------------ */

/* 第1组：标题区（主标题+副标题+分割线），延迟 0s */
.reveal-section .mod2-title,
.reveal-section .mod2-subtitle,
.reveal-section .mod2-divider {
  opacity: 0;
  transform: translateY(24px);
}

.reveal-section.is-visible .mod2-title,
.reveal-section.is-visible .mod2-subtitle,
.reveal-section.is-visible .mod2-divider {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 0.8s ease 0.1s,
    transform 0.8s ease 0.1s;
}

/* 第2组：公司介绍文字（.mod2-desc），延迟 0.2s 错开入场 */
.reveal-section .mod2-desc {
  opacity: 0;
  transform: translateY(24px);
}

.reveal-section.is-visible .mod2-desc {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 0.8s ease 0.2s,
    transform 0.8s ease 0.2s;
}

/* 第3组：右侧公司图片（.mod2-img），从右往左滑入，延迟 0.4s 最后入场；注意基础样式含 translateY(-50%) 居中，动效需合并 */
.reveal-section .mod2-img {
  opacity: 0;
  transform: translate(48px, -50%);
}

.reveal-section.is-visible .mod2-img {
  opacity: 1;
  transform: translate(0, -50%);
  transition: opacity 0.8s ease 0.3s,
    transform 0.8s ease 0.3s;
}

/* 第4组：图标行（三个图标+小字），延迟 0.5s 最后入场 */
.reveal-section .mod2-icons {
  opacity: 0;
  transform: translateY(24px);
}

.reveal-section.is-visible .mod2-icons {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 0.8s ease 0.4s,
    transform 0.8s ease 0.4s;
}

/* ============================================================
 * 模块三
 * ============================================================ */

.module-feature {
  background: #F5F5F5;
}

/* 模块三容器：相对定位 + 溢出裁切，为背景图提供定位基准 */
.module-feature .mod3-layout {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

/* 模块三背景图：absolute 铺满，cover 裁切，不响应鼠标事件；
   位于动效容器 .section-inner 之外，不参与渐入动效 */
.module-feature .mod3-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
  pointer-events: none;
  z-index: 0;
}

/* 模块三标题区：左上角定位，叠加在背景图上方 */
.module-feature .mod3-header {
  position: absolute;
  left: 180px;
  top: 200px;
  z-index: 1;
}

/* 模块三主标题：发展历程 */
.module-feature .mod3-title {
  font-size: 44px;
  font-weight: 500;
  color: #252525;
  margin: 0 0 14px 0;
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
}

/* 模块三标题下长横线 */
.module-feature .mod3-title-line {
  width: 280px;
  height: 1px;
  background: #C9C9C9;
}

/* 模块三时间轴容器：横向排列，水平轴线垂直居中 */
.module-feature .mod3-timeline {
  position: absolute;
  left: 180px;
  right: 120px;
  top: 300px;
  height: 480px;
  display: flex;
  justify-content: space-between;
  z-index: 1;
}

/* 时间轴水平主轴线 */
.module-feature .tl-line {
  position: absolute;
  left: 0;
  right: -150px;
  top: 68%;
  height: 1px;
  background: #C9C9C9;
}

/* 单个年份条目：垂直列排列，全部左对齐；相对定位 + 满高，使内部圆点/竖线以轴线位置（top:55%）为基准，不随文字换行高度变化 */
.module-feature .tl-item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 320px;
  height: 100%;
}

/* 下方条目（2025）*/
.module-feature .tl-item:nth-child(3) .tl-year {
  margin-bottom: 33px;
}

/* 下方条目（2021） */
.module-feature .tl-item:nth-child(5) .tl-year {
  margin-top: 361px;
}

/* 偶数项在轴线上方 */
.module-feature .tl-item:nth-child(even) {
  align-self: flex-start;
}

/* 奇数项在轴线下方 */
.module-feature .tl-item:nth-child(odd) {
  align-self: flex-end;
}

/* 年份文字容器：左侧带青色竖条指示器，整体上移，改 margin-left 调左右位置 */
.module-feature .tl-year {
  font-size: 30px;
  font-weight: 500;
  margin: 0 0 12px 15px;
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  display: inline-flex;
  align-items: center;
  transform: translateY(50px);
}

/* 年份数字：青色加粗 */
.module-feature .tl-year-num {
  color: #00ADBB;
  font-size: 30px;
}

/* 年份"年"字：黑色，改 font-size 调大小 */
.module-feature .tl-year-char {
  color: #252525;
  font-size: 26px;
}

/* 青色指示器：43px 长，覆盖在灰色竖线尾部，层级在竖线上方 */
.module-feature .tl-year-bar {
  position: absolute;
  left: 0;
  width: 3px;
  height: 43px;
  background: #00ADBB;
  //margin-left: -20px;
  z-index: 2;
}

/* 2025/2021：指示器盖在竖线尾部（顶端） */
.module-feature .tl-year-bar-2025,
.module-feature .tl-year-bar-2021 {
  bottom: -25%;
  margin-right: 40px;
}

/* 2026/2024：指示器盖在竖线尾部（底端） */
.module-feature .tl-year-bar-2026,
.module-feature .tl-year-bar-2024 {
  top: 11%;
  margin-left: 0;
}

/* 年份描述文字：灰色小字，改 margin 第二个值（左）调左右位置 */
.module-feature .tl-desc {
  font-size: 16px;
  font-weight: 400;
  color: #252525;
  line-height: 1.8;
  margin: 10px 10px 10px 15px;
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  transform: translateY(35px);
}

/* ============================================================
 * 四个年份独立调节（字号、间距，中英文分开）
 * 2026=第2项, 2025=第3项, 2024=第4项, 2021=第5项
 * ============================================================ */

/* 2026年 */
.module-feature .tl-item:nth-child(2) .tl-year { font-size: 30px; margin: 0 0 12px 15px; }
.module-feature .tl-item:nth-child(2) .tl-desc { font-size: 16px; margin: 10px 10px 10px 15px; }
:lang(en) .module-feature .tl-item:nth-child(2) .tl-year { font-size: 30px; margin: 0 0 12px 15px; }
:lang(en) .module-feature .tl-item:nth-child(2) .tl-desc { font-size: 16px; margin: 10px 10px 10px 15px; line-height: 1.4; }

/* 2025年 */
.module-feature .tl-item:nth-child(3) .tl-year { font-size: 30px; margin: 405px 0 12px 15px; }
.module-feature .tl-item:nth-child(3) .tl-desc { font-size: 16px; margin: 10px 10px 10px 15px; }
:lang(en) .module-feature .tl-item:nth-child(3) .tl-year { font-size: 30px; margin: 400px 0 12px 15px; }
:lang(en) .module-feature .tl-item:nth-child(3) .tl-desc { font-size: 16px; margin: 10px 10px 10px 15px;line-height: 1.4; }

/* 2024年 */
.module-feature .tl-item:nth-child(4) .tl-year { font-size: 30px; margin: 0 0 12px 15px; }
.module-feature .tl-item:nth-child(4) .tl-desc { font-size: 16px; margin: 10px 10px 10px 15px; }
:lang(en) .module-feature .tl-item:nth-child(4) .tl-year { font-size: 30px; margin: 0 0 12px 15px; }
:lang(en) .module-feature .tl-item:nth-child(4) .tl-desc { font-size: 16px; margin: 10px 10px 10px 15px; line-height: 1.4; }

/* 2021年 */
.module-feature .tl-item:nth-child(5) .tl-year { font-size: 30px; margin: 430px 0 12px 15px; }
.module-feature .tl-item:nth-child(5) .tl-desc { font-size: 16px; margin: 10px 10px 10px 15px; }
:lang(en) .module-feature .tl-item:nth-child(5) .tl-year { font-size: 30px; margin: 415px 0 12px 15px; }
:lang(en) .module-feature .tl-item:nth-child(5) .tl-desc { font-size: 16px; margin: 10px 10px 10px 15px; line-height: 1.4; }

/* 四条竖线公共样式：统一长度 270px，改 height 调长度 */
.module-feature .tl-stem-2026,
.module-feature .tl-stem-2025,
.module-feature .tl-stem-2024,
.module-feature .tl-stem-2021 {
  position: absolute;
  left: 0;
  width: 1px;
  height: 270px;
  background: #C9C9C9;
  margin-left: 1px;
}

/* 上方竖线（2026/2024）：从轴线向上延伸 */
.module-feature .tl-stem-2026,
.module-feature .tl-stem-2024 {
  top: 68%;
  transform: translateY(-270px);
}

/* 下方竖线（2025/2021）：从轴线向下延伸 */
.module-feature .tl-stem-2025,
.module-feature .tl-stem-2021 {
  top: 69%;
  transform: translateY(0);
}

/* 2026年圆点：高亮青色，钉在轴线上（top 与竖线一致），不随文字高度变化 */
.module-feature .tl-node-2026 {
  position: absolute;
  top: 68%;
  left: 0;
  width: 10px;
  height: 10px;
  margin-left: -3px;
  border-radius: 50%;
  background: #00ADBB;
  border: 2px solid #00ADBB;
  flex-shrink: 0;
  transform: translateY(-50%);
}

/* 2026年圆点外环：伪元素实心边框圆环，与中心圆有间距 */
.module-feature .tl-node-2026::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 12px;
  height: 12px;
  margin-left: -8px;
  margin-top: -8px;
  border-radius: 50%;
  background: transparent;
  border: 2px solid #00ADBB;
  pointer-events: none;
}

/* 2025/2024/2021年圆点：灰色实心圆 + 外圈圆环（伪元素实现），颜色 #B3B3B3 */
.module-feature .tl-node-2025,
.module-feature .tl-node-2024,
.module-feature .tl-node-2021 {
  position: absolute;
  top: 68%;
  left: 0;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #B3B3B3;
  border: 2px solid #B3B3B3;
  flex-shrink: 0;
  transform: translateY(-50%);
}

.module-feature .tl-node-2025 { margin-left: -3px; }
.module-feature .tl-node-2024 { margin-left: -2px; }
.module-feature .tl-node-2021 { margin-left: -3px; }

/* 2025/2024/2021年圆点外环：伪元素实心边框圆环，与中心圆有间距 */
.module-feature .tl-node-2025::after,
.module-feature .tl-node-2024::after,
.module-feature .tl-node-2021::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 12px;
  height: 12px;
  margin-left: -8px;
  margin-top: -8px;
  border-radius: 50%;
  background: transparent;
  border: 2px solid #B3B3B3;
  pointer-events: none;
}

/* ============================================================
 * 模块四
 * ============================================================ */

.module-contact {
  background: #FFFFFF;
}

/* 模块四容器：相对定位，为内部元素提供定位基准 */
.module-contact .mod4-layout {
  position: relative;
  width: 100%;
  height: 100%;
  top: 20%;
}

/* 模块四标题区：居中定位 */
.module-contact .mod4-header {
  position: absolute;
  left: 50%;
  top: 0%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* 模块四主标题 */
.module-contact .mod4-title {
  font-size: 44px;
  font-weight: 500;
  color: #252525;
  margin: 0 0 16px 0;
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
}

/* 模块四标题下长横线 */
.module-contact .mod4-title-line {
  width: 420px;
  height: 1px;
  background: #C9C9C9;
}

/* 模块四左侧文字区：公司名称 + 联系方式 */
.module-contact .mod4-left {
  position: absolute;
  left: 360px;
  top: 20%;
}

/* 仅英文生效：左侧文字整块（公司名+售后+商务）单独调位置，改 translate 两个值（向右、向下），不影响右侧图片 */
:lang(en) .module-contact .mod4-left {
  transform: translate(0, 0);
}

/* 模块四公司名称：青色大字 */
.module-contact .mod4-company {
  font-size: 36px;
  font-weight: 500;
  color: #00ADBB;
  margin: 0 0 30px 0;
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
}

/* 仅英文生效：公司名称（Shenzhen Cofoe Biotechnology...）单独调字号，只改 font-size */
:lang(en) .module-contact .mod4-company {
  font-size: 33px;
}

/* 模块四公司名称下短横线 */
.module-contact .mod4-company-line {
  width: 40px;
  height: 2px;
  background: #B3B3B3;
  margin-bottom: 24px;
}

/* 模块四小节标题：售后服务/商务联系/公司地址 */
.module-contact .mod4-section-title {
  font-size: 28px;
  font-weight: 500;
  color: #252525;
  margin: 0 0 4px 0;
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
}

/* 仅英文生效：小节标题与下方邮箱行的两行间距，改 margin-bottom */
:lang(en) .module-contact .mod4-section-title {
  margin-bottom: 20px;
}

/* 模块四联系方式文字：青色 */
.module-contact .mod4-info {
  font-size: 22px;
  font-weight: 400;
  color: #00ADBB;
  margin: 0 0 4px 0;
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
}

/* 模块四联系方式标签：黑色（邮箱：/电话：） */
.module-contact .mod4-info-label {
  color: #252525;
}

/* 模块四联系方式值：青色（邮箱地址/电话号码） */
.module-contact .mod4-info-value {
  color: #00ADBB;
}

/* 模块四小节间距 */
.module-contact .mod4-section {
  margin-bottom: 32px;
}

/* 仅英文生效：售后/商务两个小节之间的间距，改 margin-bottom */
:lang(en) .module-contact .mod4-section {
  margin-bottom: 60px;
}

/* 模块四二维码横向容器：桌面端不影响子元素绝对定位 */
.module-contact .mod4-qr-row {
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.module-contact .mod4-qr-item {
  position: static;
}

/* 模块四右侧图片一：垂直居中，靠左排布（图二在右） */
.module-contact .mod4-img1 {
  position: absolute;
  right: 750px;
  top: 28%;
  transform: translateY(-50%);
  width: 150px;
  height: auto;
  border: 2px solid #00ADBB;
  border-radius: 12px;
}

/* 模块四右侧图片二：垂直居中，最靠右 */
.module-contact .mod4-img2 {
  position: absolute;
  right: 450px;
  top: 28%;
  transform: translateY(-50%);
  width: 150px;
  height: auto;
  border: 2px solid #00ADBB;
  border-radius: 12px;
}

/* 模块四二维码标签：位于二维码图片下方，青色文字 */
.module-contact .mod4-qr-label {
  position: absolute;
  font-size: 16px;
  color: #00ADBB;
  text-align: center;
  white-space: pre-line;
  line-height: 1.6;
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
}

/* 二维码标签一：对应 img1 */
.module-contact .mod4-qr-label1 {
  right: 750px;
  top: 35%;
  width: 150px;
}

/* 二维码标签二：对应 img2 */
.module-contact .mod4-qr-label2 {
  right: 450px;
  top: 35%;
  width: 150px;
}

/* 模块四公司地址区：位于二维码下方 */
.module-contact .mod4-address {
  position: absolute;
  right: 380px;
  top: 44%;
  width: 520px;
}

/* 模块四地址描述文字 */
.module-contact .mod4-address-desc {
  font-size: 20px;
  color: #252525;
  line-height: 1.7;
  margin: 0;
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
}

/* 仅英文生效：公司地址容器位置单独调节（改 top 调上下位置） */
:lang(en) .module-contact .mod4-address {
  top: 45.3%;
}

/* 仅英文生效：地址文字字号单独调节 */
:lang(en) .module-contact .mod4-address-desc {
  font-size: 18px;
}

/* 仅英文生效：地址文字左右两端对齐*/
:lang(en) .module-contact .mod4-address-desc {
  text-align: justify;
}

/* ============================================================
 * 页脚与动效降级
 * ============================================================ */

/* 页脚作为独立吸附单元，紧跟模块四下方，与下载中心页脚逻辑一致 */
.about-page >>> .footer {
  scroll-snap-align: end;
}







/* ============================================================
 * 移动端适配（<= 1024px）骨架：禁用画布缩放，由页面级媒体查询逐步接管模块布局，
 * !important 覆盖行内 transform（JS 缩放值）
 * ============================================================ */
@media (max-width: 1024px) {
  .section-canvas {
    transform: none !important;
    transform-origin: top left !important;
    width: 100% !important;
    height: 100% !important;
  }

  /* 全部流式项禁止被 flex 压缩：内容总高超出整屏时，
     细元素（1px 分割线等）会被默认收缩直接压成 0 而消失，
     超出部分应落到底部裁切区而不是压缩内容 */
  .about-page .section-inner * {
    flex-shrink: 0;
  }

  /* ---------- 模块一：英雄区 ---------- */
  /* 背景图已 absolute 铺满 cover，手机端直接生效；文字按钮保持居中叠加 */

  /* 内容容器：纵向间距 + 两侧留白 */
  .module-hero .mod1-content {
    gap: 3vh;
    padding: 0 ;
  }

  /* 主标题字号 */
  .module-hero .mod1-title {
    font-size: 7.5vw;
    letter-spacing: 1vw;
  }

  :lang(en) .module-hero .mod1-title {
    font-size: 7.5vw;
    letter-spacing: 1vw;
  }

  /* 副标题字号 + 居中 */
  .module-hero .mod1-subtitle {
    font-size: 4.8vw;
    letter-spacing: 0.5vw;
    text-align: center;
  }

  :lang(en) .module-hero .mod1-subtitle {
    font-size: 4.8vw;
    letter-spacing: 0.5vw;
  }

  /* 按钮字号 + 内边距 */
  .module-hero .mod1-btn {
    font-size: 4.27vw;
    padding: 1.5vh 7vw;
  }

  /* ---------- 模块二：公司简介 ---------- */

  /* 容器：垂直居中改顶对齐 + padding-top 预留固定导航栏，绝对定位子项改文档流纵向堆叠 */
  .module-intro .mod2-layout {
    justify-content: flex-start;
    padding-top: 76px;
  }

  /* 标题区：绝对定位改文档流通栏（两侧 6% 留白） */
  .module-intro .mod2-header {
    position: static;
    width: 100%;
    box-sizing: border-box;
    padding: 0 6%;
  }

  .module-intro .mod2-title {
    font-size: 6.4vw;
    margin: 0 0 1vh 0;
  }

  :lang(en) .module-intro .mod2-title {
    font-size: 6.4vw;
  }

  .module-intro .mod2-subtitle {
    font-size: 4.27vw;
  }

  :lang(en) .module-intro .mod2-subtitle {
    font-size: 4.27vw;
  }

  /* 分割线：绝对定位改文档流，与标题区左边缘对齐 */
  .module-intro .mod2-divider {
    position: static;
    align-self: flex-start;
    width: 40vw;
    margin: 2vh 0 2vh 6%;
  }

  /* 公司介绍文字：绝对定位改文档流通栏 */
  .module-intro .mod2-desc {
    position: static;
    width: auto;
    box-sizing: border-box;
    padding: 0 6%;
    font-size: 3.8vw;
    line-height: 1.5;
  }

  :lang(en) .module-intro .mod2-desc {
    font-size: 3.4vw;
  }

  /* 图标行：绝对定位改文档流（改 gap 调图标间距） */
  .module-intro .mod2-icons {
    position: static;
    margin-top: 2vh;
    gap: 16vw;
  }

  .module-intro .mod2-icon {
    width: 4vh;
  }

  .module-intro .mod2-icon-label {
    font-size: 3.2vw;
    margin-top: -1.5vh;
  }

  :lang(en) .module-intro .mod2-icon-label {
    font-size: 3vw;
  }

  /* 公司图片：绝对定位改文档流（改 width/max-height 调大小） */
  .module-intro .mod2-img {
    position: static;
    width: 100%;
    max-height: 32vh;
    object-fit: contain;
    margin-top: 2vh;
    transform: none;
  }

  /* 动效：从下到上入场 */
  .reveal-section .mod2-img {
    transform: translateY(48px);
  }

  .reveal-section.is-visible .mod2-img {
    transform: translateY(0);
  }

  /* ---------- 模块三：发展历程 ---------- */
  /* ============================================================
   * 模块三：发展历程
   * 横向时间轴 → 纵向列表，主轴线转左侧竖线
   * ============================================================ */

  /* 容器：绝对定位改文档流顶对齐 */
  .module-feature .mod3-layout {
    justify-content: flex-start;
    padding-top: 76px;
  }

  /* 标题区：绝对定位改文档流 */
  .module-feature .mod3-header {
    position: static;
    align-self: stretch;
    padding: 0 6%;
  }

  .module-feature .mod3-title {
    font-size: 5.87vw;
    margin: 0 0 2vh 0;
  }

  :lang(en) .module-feature .mod3-title {
    font-size: 5.87vw;
  }

  .module-feature .mod3-title-line {
    width: 30vw;
  }

  /* 时间轴容器：横向改纵向列表 */
  .module-feature .mod3-timeline {
    position: static;
    height: auto;
    display: flex;
    flex-direction: column;
    gap: 3vh;
    width: 100%;
    box-sizing: border-box;
    padding: 3vh 6% 2vh 9vw;
  }

  /* 主轴线：横改竖，钉在左侧 */
  .module-feature .tl-line {
    position: absolute;
    left: 3vw;
    right: auto;
    top: 0;
    bottom: 0;
    height: auto;
    width: 1px;
  }

  /* 条目：改文档流，宽度自适应 */
  .module-feature .tl-item {
    position: relative;
    width: auto;
    height: auto;
    padding-left: 5vw;
  }

  /* 桌面交错对齐手机端重置为通栏 */
  .module-feature .tl-item:nth-child(even),
  .module-feature .tl-item:nth-child(odd) {
    align-self: stretch;
  }

  /* 年份文字：覆盖桌面端 nth-child 规则，清除桌面 transform 偏移 */
  .module-feature .tl-item:nth-child(2) .tl-year,
  .module-feature .tl-item:nth-child(3) .tl-year,
  .module-feature .tl-item:nth-child(4) .tl-year,
  .module-feature .tl-item:nth-child(5) .tl-year {
    transform: none !important;
    margin: 0 0 1vh 0 !important;
  }

  /* 年份数字（实际显示的文字，改这个调字号） */
  .module-feature .tl-year-num {
    font-size: 6vw !important;
  }

  :lang(en) .module-feature .tl-year-num {
    font-size: 5.5vw !important;
  }

  /* 年份"年"字 */
  .module-feature .tl-year-char {
    font-size: 4.6vw !important;
  }

  :lang(en) .module-feature .tl-item:nth-child(2) .tl-year,
  :lang(en) .module-feature .tl-item:nth-child(3) .tl-year,
  :lang(en) .module-feature .tl-item:nth-child(4) .tl-year,
  :lang(en) .module-feature .tl-item:nth-child(5) .tl-year {
    margin: 0 0 1vh 0 !important;
  }

  /* 描述文字：覆盖桌面端 nth-child 规则 */
  .module-feature .tl-item:nth-child(2) .tl-desc,
  .module-feature .tl-item:nth-child(3) .tl-desc,
  .module-feature .tl-item:nth-child(4) .tl-desc,
  .module-feature .tl-item:nth-child(5) .tl-desc {
    transform: none !important;
    font-size: 3.8vw !important;
    text-align: justify;
    line-height: 1.5;
    margin: 0 0 2vh 0 !important;
  }

  :lang(en) .module-feature .tl-item:nth-child(2) .tl-desc,
  :lang(en) .module-feature .tl-item:nth-child(3) .tl-desc,
  :lang(en) .module-feature .tl-item:nth-child(4) .tl-desc,
  :lang(en) .module-feature .tl-item:nth-child(5) .tl-desc {
    font-size: 3vw !important;
    text-align: justify;
    line-height: 1.4;
    margin: 0 0 2vh 0 !important;
  }

  /* 青色指示器：手机端隐藏（纵向列表不需要） */
  .module-feature .tl-year-bar,
  .module-feature .tl-year-bar-2025,
  .module-feature .tl-year-bar-2021,
  .module-feature .tl-year-bar-2026,
  .module-feature .tl-year-bar-2024 {
    display: none;
  }

  /* 横向连接线手机端隐藏 */
  .module-feature .tl-stem-2026,
  .module-feature .tl-stem-2025,
  .module-feature .tl-stem-2024,
  .module-feature .tl-stem-2021 {
    display: none;
  }

  /* 圆点：钉在左侧竖线上年份行高处 */
  .module-feature .tl-node-2026,
  .module-feature .tl-node-2025,
  .module-feature .tl-node-2024,
  .module-feature .tl-node-2021 {
    position: absolute;
    top: 1.4vh;
    left: -6vw;
    margin-left: -5px;
    transform: translateY(-50%);
  }

  /* ---------- 模块四：商务联系 ---------- */

  /* 容器：绝对定位子项改文档流顶对齐纵向堆叠 */
  .module-contact .mod4-layout {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding: 76px 0 3vh;
    top: auto;       /* 覆盖桌面端 top:20% */
  }

  .module-contact .mod4-header {
    position: static;
    transform: none;
  }

  .module-contact .mod4-title {
    font-size: 5.87vw;
    margin: 0 0 2vh 0;
  }

  :lang(en) .module-contact .mod4-title {
    font-size: 5.87vw;
  }

  .module-contact .mod4-title-line {
    width: 56vw;
  }

  /* 左侧文字区：绝对定位改文档流通栏（改 width 调两侧留白） */
  .module-contact .mod4-left {
    position: static;
    width: 88%;
    margin-top: 3vh;
  }

  .module-contact .mod4-company {
    font-size: 5.6vw;
    margin: 0 0 2vh 0;
  }

  :lang(en) .module-contact .mod4-company {  /* 公司名（英文单独调节字号） */
    font-size: 4.6vw;
  }

  .module-contact .mod4-company-line {
    margin-bottom: 3vh;
  }

  .module-contact .mod4-section-title {
    font-size: 4.8vw;
    margin: 0 0 1.5vh 0;
  }

  :lang(en) .module-contact .mod4-section-title {
    margin-bottom: 1.5vh;
  }

  .module-contact .mod4-info {
    font-size: 4.27vw;
    margin: 0 0 1vh 0;
    word-break: break-all;   /* 长邮箱地址允许断行防溢出 */
  }

  :lang(en) .module-contact .mod4-info {
    font-size: 4.27vw;
  }

  .module-contact .mod4-section {
    margin-bottom: 3vh;
  }

  :lang(en) .module-contact .mod4-section {
    margin-bottom: 3vh;
  }

  /* 二维码横向容器：手机端两列并排 */
  .module-contact .mod4-qr-row {
    position: static;
    display: flex;
    justify-content: center;
    gap: 8vw;
    width: 100%;
    margin-top: 0vh;
    order: 1;
  }

  .module-contact .mod4-qr-item {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .module-contact .mod4-img1,
  .module-contact .mod4-img2 {
    position: static;
    transform: none;
    width: 14vh;
  }

  .module-contact .mod4-qr-label1,
  .module-contact .mod4-qr-label2 {
    position: static;
    width: auto;
    margin-top: 0vh;
    font-size: 3.73vw;
    text-align: center;
  }

  .module-contact .mod4-address {
    position: static;
    width: 88%;
    margin-top:-63vh;
    order: 2;
    top: auto; /* 覆盖桌面端英文的 top: 27.3% */
  }

  /* 仅英文生效：手机端地址容器上边距单独调节（改 margin-top 调上下位置） */
  :lang(en) .module-contact .mod4-address {
    margin-top: 2vh; /* 改这个值调英文地址文字的上下位置，负值越小越靠上 */
  }

  .module-contact .mod4-address-desc {
    font-size: 4vw;
  }

  :lang(en) .module-contact .mod4-address-desc {
    font-size: 4vw;

  }
}

@media (prefers-reduced-motion: reduce) {
  .reveal-section .section-inner {
    transition: none;
    opacity: 1;
    transform: none;
  }
}
</style>
